// App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import MainLayout from './layouts/MainLayout';
import AdminDashboard from './pages/AdminDashboard';
import CollectionPage from './pages/CollectionPage';
import SupplyDemandPage from './pages/SupplyDemandPage';
import LogCenterPage from './pages/LogCenterPage';
import DataManagementPage from './pages/DataManagementPage';
import ConfigPage from './pages/ConfigPage';
import AssetPage from './pages/AssetPage';
import OperationsPage from './pages/OperationsPage';
import UserPage from './pages/UserPage';
import AlertPage from './pages/AlertPage';
import CloudPlatformPage from './pages/CloudPlatformPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="admin" element={<AdminDashboard />} />
        <Route path="collection" element={<CollectionPage />} />
        <Route path="supply" element={<SupplyDemandPage />} />
        <Route path="logs" element={<LogCenterPage />} />
        <Route path="data" element={<DataManagementPage />} />
        <Route path="config" element={<ConfigPage />} />
        <Route path="assets" element={<AssetPage />} />
        <Route path="operations" element={<OperationsPage />} />
        <Route path="alerts" element={<AlertPage />} />
        <Route path="user" element={<UserPage />} />
        <Route path="cloud" element={<CloudPlatformPage />} />
      </Route>
    </Routes>
  );
}

export default App;
